"use client";
import React from "react";
import { HiChevronRight, HiChevronLeft } from "react-icons/hi2";

const Pagination = ({
  currentPage,
  totalPages,
  visiblePages,
  handlePageChange,
}) => {
  return (
    <div className="flex items-center justify-center mt-8 flex-wrap border-white">
      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`px-2 py-2 border border-white  disabled:opacity-50 ${currentPage === 1 ? "colorBlack" : "colorBlue"}`}
      >
        <HiChevronLeft size={25} />
      </button>

      {visiblePages.map(page => (
        <button
          key={page}
          onClick={() => handlePageChange(page)}
          className={`px-4 py-2 border  border-white ${
            currentPage === page ? "colorBlack" : "colorBlue"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-2 py-2 border  border-white disabled:opacity-50 ${currentPage === totalPages ? "colorBlack" : "colorBlue"}`}
      >
        <HiChevronRight size={25} />
      </button>
    </div>
  );
};

export default Pagination;
